import {
    makeStyles,
    Menu,
    MenuButton,
    MenuGroup,
    MenuGroupHeader,
    MenuItemRadio,
    MenuList,
    MenuPopover,
    MenuTrigger,
    Persona,
    tokens,
} from '@fluentui/react-components';
import { CameraSwitchRegular, DarkThemeRegular, LightbulbRegular } from '@fluentui/react-icons';
import { useRouteContext } from '@tanstack/react-router';
import { useThemeContext } from '../theme/ThemeContext';

const useStyles = makeStyles({
    flexLeft: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
    },
    flexCenter: {
        flex: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    flexRight: {
        flex: 1,
        gap: '1em',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    persona: {
        '& .fui-Persona__primaryText': {
            color: tokens.colorNeutralForegroundStaticInverted,
        },
        cursor: 'pointer',
    },
    header: {
        alignItems: 'center',
        backgroundColor: tokens.colorBrandBackgroundStatic,
        color: tokens.colorNeutralForegroundStaticInverted,
        display: 'flex',
        flexDirection: 'row',
        height: '2em',
        padding: 'var(--spacingHorizontalMNudge)',
        margin: 0,
        fontWeight: '800',
    },
    spinner: {
        flexGrow: 1,
    },
    popover: {
        zIndex: 1000,
    },
    menuItem: {
        '& > span': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '2em',
        },
    },
    menuItemHeader: {
        color: tokens.colorNeutralForeground1,
        fontWeight: '600',
    },
});

export const Header = () => {
    const styles = useStyles();
    return (
        <header className={styles.header}>
            <div className={styles.flexLeft}>{}</div>
            <div className={styles.flexCenter}>
                {/* Mittleres Segment */}
                SharePoint Step Manager
            </div>
            <div className={styles.flexRight}>
                <UserMenu />
            </div>
        </header>
    );
};

const UserMenu = () => {
    const styles = useStyles();
    const { preference, setPreferenceState } = useThemeContext();

    // const checkedValues: Record<string, string[]> = { theme: [preference] };

    return (
        <Menu positioning="below-end" inline>
            <MenuTrigger>
                <MenuButton appearance="transparent">
                    <UserPersona />
                </MenuButton>
            </MenuTrigger>

            <MenuPopover className={styles.popover}>
                <MenuList
                    checkedValues={{ theme: [preference] }}
                    onCheckedValueChange={(_, { name, checkedItems }) => {
                        if (name === 'theme') {
                            // const next = checkedItems[0] as 'system' | 'light' | 'dark';
                            setPreferenceState(checkedItems[0] as any);
                        }
                    }}
                >
                    <MenuGroup>
                        <MenuGroupHeader className={styles.menuItemHeader}>Theme</MenuGroupHeader>

                        <MenuItemRadio name="theme" value="system" icon={<CameraSwitchRegular />}>
                            Automatisch (System)
                        </MenuItemRadio>

                        <MenuItemRadio name="theme" value="light" icon={<LightbulbRegular />}>
                            Hell
                        </MenuItemRadio>

                        <MenuItemRadio name="theme" value="dark" icon={<DarkThemeRegular />}>
                            Dunkel
                        </MenuItemRadio>
                    </MenuGroup>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

const UserPersona = () => {
    const styles = useStyles();
    const userName = useRouteContext({
        from: '__root__',
        select: (context) => context.user?.displayName,
    });
    return (
        <Persona
            name={userName || 'Unknown user'}
            size="small"
            textAlignment="center"
            className={styles.persona}
        />
    );
};
